import React, {Component} from 'react';

import {Button, ButtonGroup, Col, ListGroup, Row, ToggleButton} from "react-bootstrap";
import {request} from "../../../helper/APIUtils";
import {Card} from "react-bootstrap"
import {showAxiosError} from "../../../helper/helper";
import CreateEndpoint from "./CreateEndpoint";
import AddDocHeader from "./AddDocHeader";
import UpdateDocHeader from "./UpdateDocHeader";
import {Link} from "react-router-dom";
import Swal from "sweetalert2";
import SweetAlert from "react-bootstrap-sweetalert";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import Alert from "react-s-alert";

class DocumentationList extends Component {
    constructor(props) {
        super(props);
        this.deleteHeader = this.deleteHeader.bind(this);
        this.handleClickUpdateHeader = this.handleClickUpdateHeader.bind(this);
        this.handleClickCreateEndpoint = this.handleClickCreateEndpoint.bind(this);
        this.getEndpoint = this.getEndpoint.bind(this);
        this.state = {
            serviceDocumentation: {},
            modal: "",
            sectionRecordId: null,
            docHeaderRecordId: null,
            addHeaderTitle: "",
            headerData: null,
            sectionName: "",
            docName: "",
            alert: null
        }
    }

    componentDidMount() {
        this.getEndpoint();
    }

    deleteHeader(id, data) {
        let self = this;
        let params = {
            url: "/servicedocumentation/delete" + data + "?id=" + id,
            method: "post"
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Deleted') {
                    Swal("Başarılı!", "Veri başarıyla silindi !", "success");
                    self.getEndpoint();
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }
    passiveHeader(state, recordId) {
        let self = this;
        let params = {
            url: "/servicedocumentation/passiveDocumentation/"+state+'/'+recordId,
            method: "post",
        };
        request(params)
            .then(function (response) {
                if (response.data === 'Changed') {
                    let timerInterval
                    Swal({
                        title:"Başarılı!",
                        text:"Durum başarılı bir şekilde güncellendi !",
                        timer: 1000,
                        position: 'top-left',

                        showConfirmButton: false});
                    self.getEndpoint();
                    self.props.history.push("/serviceDocumentation/add")
                }
            }).catch(function (error) {
            Swal("Hata !", error, "error");
            showAxiosError(error);
        });
    }

    saveHeader(documentationId, data) {
        let url;
        let self = this;
        if (data !== null && data !== "") {
            if (documentationId != null)
                url = '/servicedocumentation/saveSection' + '?docId=' + documentationId;
            else
                url = '/servicedocumentation/saveDocumentation';
            let params = {
                url: url,
                method: 'post',
                data: {
                    name: data,
                    isActive: false
                }
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla eklendi !", "success")
                    self.getEndpoint();
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    updateHeader(id, url, name) {
        let self = this;
        let sendUrl = '/servicedocumentation/update' + url;
        if (name !== null && name !== "") {
            let params = {
                url: sendUrl,
                method: 'post',
                data: {
                    recordId: id,
                    name: name
                }
            };
            request(params)
                .then(function (response) {
                    Swal("Başarılı!", "Veri başarıyla güncellendi !", "success");
                    self.getEndpoint();
                }).catch(function (error) {
                Swal("Hata !", error, "error");
                showAxiosError(error);
            });
        }
    }

    handleClickCreateEndpoint(data, sectionRecordId, secName, docName) {
        this.setState({sectionRecordId: sectionRecordId, sectionName: secName, docName: docName, modal: data});
    }

    handleClickEditHeader = (recordId) => {
        let title;
        if (recordId !== null)
            title = 'Dokümantasyon Bölümü';
        else
            title = 'Dokümantasyon Başlığı';
        Swal({
            title: title + ' Ekle',
            input: 'text',
            showCancelButton: true,
            confirmButtonText: 'Tamam',
            cancelButtonText: 'Hayır',
            inputValidator: (value) => {
                if (value === "")
                    return title + ' boş bırakılamaz!'
                this.saveHeader(recordId, value)
            }

        });
    }

    getEndpoint() {
        let self = this;
        let params = {
            url: "/servicedocumentation/findAllDocumentationDto",
            method: "get"
        };
        request(params)
            .then(function (response) {
                let serviceDocumentation = response.data;
                self.setState({serviceDocumentation: serviceDocumentation});
                self.props.setServiceDocumentation(serviceDocumentation);
            });
    }

    updateDocList = (docList) =>{
        let self = this;
        let error = null;
        if(docList && docList.length>0){
                let params = {
                    url : '/servicedocumentation/updateDocumentationList',
                    method: 'post',
                    data: docList
                };
                request(params).
                then(function (response) {
                    Alert.success('Lista başarılı bir şekilde güncellendi !', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    self.props.setServiceDocumentation(docList);

                }).catch(function (error) {
                    showAxiosError(error);
                });


            if(!error){

            }
        }


    }

    handleClickUpdateHeader(id, url,headerData) {
        let title;
        if (url === "Documentation")
            title = "Dokümantasyon Başlığı";
        else if (url === "Section")
            title = "Dokümantasyon Bölümü";
        if (id !== null && url !== null) {
            Swal({
                title: title + " Düzenleme",
                input: 'text',
                inputValue:headerData,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (value === "")
                        return title + ' boş bırakılamaz!'
                    else
                        this.updateHeader(id, url, value);
                }
            });
        }
    }

    dragHandler = (param) =>{
        const srcI = param.source.index;
        const desI = param.destination.index;
        let docList = this.state.serviceDocumentation;
        docList.splice(desI,0,docList.splice(srcI,1)[0]);
        docList.forEach((doc,i)=>{
            doc.sortNumber = i;
        })
        this.updateDocList(docList);
    }

    render() {


        return (
            <div>
                {this.state.alert}
                    <Card className="customCard">
                        <Card.Header className="" style={{background: "#00000008"}}>
                            <div className="service-list-card-header">
                                <div className="service-list-card-header-title">
                                    Dokümantasyonlar
                                </div>
                                <ButtonGroup style={{float: "right"}}>
                                    <Button variant="outline-info" className="btnAdd"
                                            title="Dokümantasyon Başlığı oluşturmak için tıklayın."
                                            onClick={() => this.handleClickEditHeader(null)}>
                                        Dokümantasyon Ekle
                                    </Button>
                                    <Button variant="outline-secondary" className="btnResponse" onClick={() => this.props.sectionCallback()}>
                                        <Link
                                            style={{float: "right"}}
                                            title="Hata kodlarını düzenlemek için tıklayın."
                                            to="/serviceDocumentation/listResponseCode">
                                            Hata Kodu Ekle
                                        </Link>
                                    </Button>

                                </ButtonGroup>
                            </div>
                        </Card.Header>
                        <Card.Body className="customCardBody">
                            {this.state.serviceDocumentation && this.state.serviceDocumentation.length > 0 &&
                                <DragDropContext onDragEnd={(params) => this.dragHandler(params)}>
                                    <Droppable droppableId="droppable-1">
                                        {(provided, snapshot) => (
                                            <div className="customCard-doclist-card-container" md={6} key={1} {...provided.droppableProps} ref={provided.innerRef}>
                                                {this.state.serviceDocumentation.map((data, i) =>
                                                        <Draggable key={data.recordId} draggableId={"draggable-"+data.recordId} index={i}>
                                                            {(provided) => (
                                                                <Card className="customCard-doclist-single-card"
                                                                      {...provided.draggableProps} ref={provided.innerRef}>
                                                                    <Card.Header className="documentation-list-card-header">
                                                                            <div className="documentation-list-card-title">
                                                                                <div {...provided.dragHandleProps} className="documentation-list-card-icon"><i className="fas fa-bars"></i></div>
                                                                                <Link to={`DocumentationDetails/${data.recordId}`}>{data.name}</Link>
                                                                            </div>
                                                                            <ButtonGroup
                                                                                className="documentation-list-card-btns">
                                                                                <Button size="sm"
                                                                                        disabled={data.isActive}
                                                                                        variant="success"
                                                                                        onClick={() => this.passiveHeader(true, data.recordId)}>Aktif</Button>
                                                                                <Button size="sm"
                                                                                        disabled={!data.isActive}
                                                                                        variant="secondary"
                                                                                        onClick={() => this.passiveHeader(false, data.recordId)}>Pasif</Button>

                                                                                <Button size="sm"
                                                                                        className="card-title-deleteBtn"
                                                                                        title="Dokümantasyon başlığını silmek için tıklayın.Bu işlem altındaki dokümantasyonların hepsini siler."
                                                                                        onClick={() => this.setState({
                                                                                            alert: (<SweetAlert
                                                                                                showCancel warning
                                                                                                cancelBtnText="Hayır"
                                                                                                confirmBtnText="Evet"
                                                                                                confirmBtnBsStyle="danger"
                                                                                                cancelBtnBsStyle="default"
                                                                                                title="Bu İşlemi Yapmak İstediğinize Emin Misiniz?"
                                                                                                onCancel={() => this.setState({alert: null})}
                                                                                                onConfirm={() =>
                                                                                                    this.deleteHeader(data.recordId, "Documentation") &
                                                                                                    this.setState({alert: null})
                                                                                                }>
                                                                                                {"Dokümantasyon başlığını silerseniz altındaki dokümantasyonların hepsini siler."}
                                                                                            </SweetAlert>)
                                                                                        })}>
                                                                                    <span><i
                                                                                        className="fas fa-trash-alt"></i></span>
                                                                                </Button>

                                                                            </ButtonGroup>

                                                                        </Card.Header>
                                                                </Card>
                                                            )}
                                                        </Draggable>
                                                    )}
                                                {provided.placeholder}

                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            }
                        </Card.Body>
                    </Card>
                {this.state.modal === "createEndpoint" &&
                <CreateEndpoint onOpen={this.handleClickCreateEndpoint}
                                sectionRecordId={this.state.sectionRecordId}
                                secName={this.state.sectionName}
                                docName={this.state.docName}
                                refresh={this.getEndpoint}
                />
                }

                {this.state.modal === "addDocHeader" &&
                <AddDocHeader onClickStatus={this.handleClickEditHeader}
                              docHeaderRecordId={this.state.docHeaderRecordId}
                              headerTitle={this.state.addHeaderTitle}
                              refresh={this.getEndpoint}/>
                }

                {this.state.modal === "updateDocHeader" &&
                <UpdateDocHeader onClickStatus={this.handleClickUpdateHeader}
                                 sectionId={this.state.sectionRecordId}
                                 docId={this.state.documentationRecordId}
                                 headerTitle={this.state.addHeaderTitle}
                                 defaultData={this.state.headerData}
                >
                </UpdateDocHeader>}

            </div>
        );
    }
}

export default DocumentationList;